export const Name = 'link-click';
export const LinkClick = Name;
//# sourceMappingURL=index.js.map